import { render, staticRenderFns } from "./admin-visitors.vue?vue&type=template&id=49226335"
import script from "./admin-visitors.vue?vue&type=script&lang=js"
export * from "./admin-visitors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports